import api from '../../../services/api';
import { useState, useEffect } from "react";
import { Link, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import LocalGasStationOutlinedIcon from '@mui/icons-material/LocalGasStationOutlined';
import OilBarrelOutlinedIcon from '@mui/icons-material/OilBarrelOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PageContainer from '../../../common/components/PageContainer';
import PageHeader from '../../../common/components/PageHeader';
import usePermissoes from '../../../common/hooks/usePermissoes';
import Permissoes from '../../../common/permissoes';

function VeiculoOpcoes() {
    const { hasPermission } = usePermissoes();
    const [veiculo, setVeiculo] = useState({});
    const { id } = useParams();

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get(`/veiculo/${id}`);
                setVeiculo(response.data);
            } catch (error) {
                console.error('Erro ao buscar o veículo:', error);
            }
        }
        fetchData();
    }, [id]);

    const opcoes = [
        { label: 'Abastecer', to: `/veiculo/${veiculo.id}/abastecimento`, icon: <LocalGasStationOutlinedIcon color="primary" sx={{ fontSize: 40 }} /> },
        { label: 'Trocar Óleo', to: `/veiculo/${veiculo.id}/trocaoleo`, icon: <OilBarrelOutlinedIcon color="primary" sx={{ fontSize: 40 }} /> },
        { label: 'Manutenção', to: `/veiculo/${veiculo.id}/manutencao`, icon: <BuildOutlinedIcon color="primary" sx={{ fontSize: 40 }} /> },
        ...(hasPermission(Permissoes.VEICULO_CADASTRO)
            ? [{ label: 'Atualização', to: `/veiculo/${veiculo.id}/atualizacao`, icon: <EditOutlinedIcon color="secondary" sx={{ fontSize: 40 }} /> }]
            : []),
    ];

    return (
        <PageContainer>
            <PageHeader title={`${veiculo.marca || ''} ${veiculo.tipo || ''}`} />

            {veiculo.foto && (
                <Box
                    component="img"
                    src={`data:image/jpeg;base64,${veiculo.foto}`}
                    alt="Veículo"
                    sx={{ width: '100%', maxHeight: 260, objectFit: 'cover', borderRadius: 2, mb: 3 }}
                />
            )}

            <Grid container spacing={2}>
                {opcoes.map((opcao) => (
                    <Grid item xs={12} sm={6} md={3} key={opcao.label}>
                        <Card>
                            <CardActionArea component={Link} to={opcao.to} sx={{ p: 3 }}>
                                <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                                    {opcao.icon}
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{opcao.label}</Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </PageContainer>
    );
}

export default VeiculoOpcoes;
